import { useState, useEffect } from "react";
import styles from "@styles/Dashboard.module.scss";
import { useSwipeable } from "react-swipeable";
import { Text } from "@eventsquare/uikit";

interface Card {
  id: number;
  content: string;
  imageUrl: string;
}

const Dashboard: React.FC = () => {
  const cardWidth = "20rem";
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const [activeCard, setActiveCard] = useState<number>(1);

  const baseCards: Card[] = [
    {
      id: 1,
      content: "200",
      imageUrl: "https://api.eventsquare.io/qr?data=200",
    },
    {
      id: 2,
      content: "404",
      imageUrl: "https://api.eventsquare.io/qr?data=404",
    },
    {
      id: 3,
      content: "500",
      imageUrl: "https://api.eventsquare.io/qr?data=500",
    },
  ];

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const swipeLeft = () => {
    const currentIndex = baseCards.findIndex((card) => card.id === activeCard);
    const nextIndex = (currentIndex + 1) % baseCards.length;
    setActiveCard(baseCards[nextIndex].id);
  };

  const swipeRight = () => {
    const currentIndex = baseCards.findIndex((card) => card.id === activeCard);
    const prevIndex = (currentIndex - 1 + baseCards.length) % baseCards.length;
    setActiveCard(baseCards[prevIndex].id);
  };

  const swipeHandlers = useSwipeable({
    onSwipedLeft: swipeLeft,
    onSwipedRight: swipeRight,
    preventScrollOnSwipe: true,
    trackMouse: true,
  });

  return (
    <div className={styles.wrapper}>
      <div
        className={styles.container}
        style={{ "--card-width": cardWidth } as React.CSSProperties}
      >
        <div className={styles.body} {...(isMobile ? swipeHandlers : {})}>
          {isMobile ? (
            <div
              className={`${styles.cards} ${styles[`active-${activeCard}`]}`}
            >
              {baseCards.map((card) => (
                <div
                  key={card.id}
                  className={`${styles.card} ${
                    activeCard === card.id ? styles.active : ""
                  }`}
                >
                  <div className={styles.cardContent}>
                    <div className={styles.cardImage}>
                      <img
                        src={card.imageUrl}
                        alt={`QR Code ${card.content}`}
                      />
                    </div>
                    <div
                      className={styles.cardText}
                      key={`text-${card.id}-${activeCard}`}
                    >
                      <Text variant="h1" noMargin>
                        {card.content}
                      </Text>
                      <Text variant="p" noMargin>
                        {card.imageUrl}
                      </Text>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className={styles.desktopCards}>
              {baseCards.map((card) => (
                <div key={card.id} className={styles.card}>
                  <div className={styles.cardContent}>
                    <div className={styles.cardImage}>
                      <img
                        src={card.imageUrl}
                        alt={`QR Code ${card.content}`}
                      />
                    </div>
                    <div className={styles.cardText}>
                      <Text variant="h1" noMargin>
                        {card.content}
                      </Text>
                      <Text variant="p" noMargin>
                        {card.imageUrl}
                      </Text>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
